import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Paper, Skeleton } from "@mui/material";
import { Container } from "react-bootstrap";
import { NavBar, Footer, NewButton, SpeakerCards } from '../components';
import { tracking } from '../../../utils/tracking';
import { useResizeImg } from '../../../utils/useResizeImg';
import "./speakers.css";
import styles from "./speakers.module.css";

const DESKTOP_IMG_URL = '../../../../assets/events/etvs23/speakers-banner-desktop.jpg'
const MOBILE_IMG_URL = '../../../../assets/events/etvs23/speakers-banner-mobile.jpg'
const url = "https://www.youtube.com/embed/9o0uXtzun58?mute=1";

export const Speakers = () => {
   document.title = "Emerging Tech Venture Summit | Speakers";

   const [isLoading, setIsLoading] = useState(true);
   const myDiv = useRef(null);
   const imageSource = useResizeImg(DESKTOP_IMG_URL, MOBILE_IMG_URL)

   useEffect(() => {
      const script = document.createElement('script');
      script.src = 'https://js.hsforms.net/forms/embed/v2.js';
      document.body.appendChild(script);
      script.addEventListener('load', () => {
         if (window.hbspt) {
            window.hbspt.forms.create({
               region: "na1",
               portalId: '536350',
               formId: '5b40cece-7414-4263-8cee-9bc41eb4c83e',
               target: '#speakersForm',
            })
         }
      });
   });

   return (
      <div>
         <NavBar />
         <Container className={styles.banner} fluid>
            {isLoading ?
               <Skeleton animation="wave" variant="rectangular" sx={{ minHeight: imageSource === DESKTOP_IMG_URL ? '65vh' : '100vh', position: 'initial !important', backgroundColor: '#0F1A28' }}>
                  <div id="etxLoader" style={{ left: window.innerWidth > 900 ? '45%' : '40%', top: '40%' }} />
                  <img
                     onLoad={() => setIsLoading(false)}
                     src={imageSource}
                     alt='home-img'
                     style={{ visibility: 'hidden', minHeight: window.innerWidth > 1200 && "50vh", width: '100%' }}
                  />
               </Skeleton>
               :
               <img
                  src={imageSource}
                  loading="eager"
                  alt='home-img'
                  style={{ minHeight: window.innerWidth > 1200 && "50vh", width: '100%' }}
               />
            }
            {
               !isLoading &&
               <div className={styles.itemsOnImg}>
                  <h2> Learn. Engage. Thrive.</h2>
                  <div className={styles.btn} onClick={() => { tracking(287); myDiv.current.scrollIntoView({ behavior: 'smooth' }) }} >
                     <NewButton name='APPLY TO SPEAK' color='#CF1B5B' bgColor='white' borderColor='none' fontSize />
                  </div>
                  <Link to='/agenda' onClick={() => tracking(288)} className={styles.btn}>
                     <NewButton name='AGENDA' color='#CF1B5B' bgColor='white' borderColor='none' fontSize />
                  </Link>
               </div>
            }
         </Container>

         <section className='second-section' style={{ color: "white" }}>
            <div style={{ padding: "5%", display: "flex", flexDirection: "column", alignContent: "space-between", flexBasis: "100%" }}>
               <div>
                  <h3 style={{ color: "#CF1B5B", paddingBottom: "20px" }}>Informative content, wide variety of topics, & Top-Tier Speakers</h3>
                  <p>As always, we bring together a ridiculous amount of Investor Speakers and thought leaders from across the globe for two days of
                     content curated to help you maximize your potential.
                  </p>
                  <p>Our featured Speakers have over a millennia of combined years of experience, and are set to inform you on hot topics in the
                     startup and tech worlds.
                  </p>
                  <p>Check out our Featured Speakers below and we can't wait to see you there!</p>
               </div>
               <div style={{ paddingTop: "10%" }}>
                  <a href='https://youngstartup.com/upcoming' onClick={() => tracking(289)} className={styles.btn}>
                     <NewButton name='TICKETS' color='white' bgColor='#CF1B5B' borderColor='none' fontSize />
                  </a>
               </div>
            </div>

            <div style={{ flexBasis: "100%" }}>
               <div style={{
                  position: "relative",
                  paddingBottom: "56.25%",
                  height: "100%",
                  width: "100%",

                  top: "50%",
                  transform: "translateY(-50%)",
               }}>
                  <iframe style={{
                     position: "absolute",
                     top: "0",
                     left: "0",
                     width: "100%",
                     height: "100%",
                  }}
                     src={url}
                     title="YouTube video player" frameBorder="0"
                     allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen
                  />
               </div>
            </div>
         </section >
         <SpeakerCards />
         <div ref={myDiv} style={{ height: '55px', width: '100%' }} />
         <Paper elevation={3} sx={{ p: 1 }} className="fourth-section">
            <h2 style={{
               textAlign: "center",
               fontWeight: "bolder",
               paddingTop: "35px",
               background: "linear-gradient(90deg, #FF0092, #BC0D57)",
               WebkitBackgroundClip: "text",
               color: "transparent",
            }}>
               Apply to Speak
            </h2>
            <h4 style={{ textAlign: "center", color: "white", padding: '0 1em' }}>
               Fill out the form below if you’re interested in speaking or hosting a workshop
            </h4>
            <div id="speakersForm" />
         </Paper>
         <Footer />
      </div >
   )
}